<div class="cc-step-bar">
  <div *ngFor="let item of stepList; index as i;" class="step-item">
    <div class="step" [ngClass]="{'active': i === currentStep}">{{item}}</div>
    <div class="next-step-img" *ngIf="i < stepList.length - 1"></div>
  </div>
</div>
